import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { stopPropagation } from '../../../../../../utils/events'
import ButtonComponent, {
  BUTTON_HEIGHT_32,
  ButtonArrow,
} from '../../../../../Button'
import { QA_NAME_LISTING_PROFILE_READINESS_COLLAPSE_BTN } from '../RentalPortalListingProfileWidgetPublishing.constants'
import { getListingReadinessCollapseTooltipTexts } from '../RentalPortalListingProfileWidgetPublishing.utils'

function ListingProfileWidgetPublishingCollapseButton({
  isDisabled,
  isExpanded,
  tooltipKey,
  onToggle,
}) {
  function handleClick(event) {
    stopPropagation(event)

    onToggle()
  }

  return (
    <ButtonArrow
      {...getListingReadinessCollapseTooltipTexts({ isDisabled, tooltipKey })}
      isInline
      Button={ButtonComponent.Flat}
      disabled={isDisabled}
      height={BUTTON_HEIGHT_32}
      isOpen={isExpanded}
      qaName={QA_NAME_LISTING_PROFILE_READINESS_COLLAPSE_BTN}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default ListingProfileWidgetPublishingCollapseButton
